export * from '../../../node_modules/@angular/platform-browser/fesm2022/animations.mjs';
